export default __webpack_public_path__ + "static/square_w.c61fa33c59f07a5220c643735c981b25.png";